import { useFrontendContext } from '@cmctechnology/webinvest-store-frontend';
import { useTestId, Z_INDICES } from '@cmctechnology/webinvest-design-system';
import { frontendActions, OPEN_SELF_URL_TARGET } from '@cmctechnology/webinvest-store-frontend';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useStockLendingSettings } from '@cmctechnology/webinvest-store-client';

const MODAL_CLOSED_MESSAGE = 'STOCK_LENDING_INTERCEPTOR_CLOSED';
const REDIRECT_TO_WSS_MESSAGE = 'STOCK_LENDING_INTERCEPTOR_REDIRECT_TO_WSS';
const INTERCEPTOR_SOURCE = 'client.shared.react/wfe-stock-lending-interceptor/build/index.html?isFalcon=true';
const EVENT_TYPE = 'message';

const InterceptorFrame = styled.iframe`
  position: fixed;
  top: 0;
  left: 0;
  border: none;
  width: 100vw;
  height: 100vh;
  z-index: ${Z_INDICES.TOP_OVERLAY};
`;

type MessageEvent = { data?: { type?: string; url?: string } };

export const StockLendingInterceptorFrame: React.FC = () => {
  const [show, setShow] = useState(true);
  const { showInterceptor } = useStockLendingSettings();
  const { config } = useFrontendContext();
  const { generateTestId } = useTestId({}, 'StockLendingInterceptorFrame');
  useEffect(() => {
    const handleEvent = ({ data }: MessageEvent) => {
      const { type, url } = data ?? {};
      if (type === MODAL_CLOSED_MESSAGE) {
        setShow(false);
      } else if (type === REDIRECT_TO_WSS_MESSAGE && url) {
        setShow(false);
        frontendActions.redirectToUrl(url, OPEN_SELF_URL_TARGET);
      }
    };

    window.addEventListener(EVENT_TYPE, handleEvent);

    return () => {
      window.removeEventListener(EVENT_TYPE, handleEvent);
    };
  }, []);

  return show && showInterceptor ? <InterceptorFrame {...generateTestId()} src={`${config.stockbrokingUrl}/${INTERCEPTOR_SOURCE}`} /> : <></>;
};
